import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6 relative overflow-hidden">
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
          Start Shopping with OOPBuy Spreadsheet
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-10 leading-relaxed">
          Access the most updated spreadsheet system and discover thousands of curated products with price comparison and shipping insights.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
          >
            Go to Main OOPBuy Platform
            <i className="ri-arrow-right-line"></i>
          </a>
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-800 border-2 border-foreground-200 rounded-full hover:border-foreground-400 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
          >
            Browse Free Spreadsheet Guide
            <i className="ri-file-text-line"></i>
          </Link>
        </div>
      </div>

      <div className="flex flex-wrap items-end justify-center gap-4 md:gap-8 opacity-25 mt-8 relative z-0">
        <div className="w-14 h-20 md:w-20 md:h-24 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Single%20cream%20white%20sneaker%20on%20a%20warm%20oatmeal%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20style%2C%20no%20text%20no%20logos&width=200&height=240&seq=cta-prod-01-v3&orientation=portrait"
            alt="Sneakers"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-20 h-28 md:w-24 md:h-32 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20heathered%20beige%20hoodie%20folded%20on%20warm%20cream%20surface%2C%20gentle%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20no%20text%20no%20logos&width=240&height=320&seq=cta-prod-02-v3&orientation=portrait"
            alt="Hoodie"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-14 h-20 md:w-16 md:h-20 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20tan%20leather%20handbag%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20no%20text%20no%20logos&width=200&height=200&seq=cta-prod-03-v3&orientation=squarish"
            alt="Bag"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-16 h-24 md:w-20 md:h-28 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Tortoiseshell%20sunglasses%20resting%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20no%20text%20no%20logos&width=240&height=320&seq=cta-prod-04-v3&orientation=portrait"
            alt="Sunglasses"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-16 h-20 md:w-20 md:h-24 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20watch%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20no%20text%20no%20logos&width=200&height=240&seq=cta-prod-05-v3&orientation=portrait"
            alt="Watch"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}